import Vue from "vue";
import Router from "vue-router";
Vue.use(Router);
// 解决重复点击导航时，控制台出现报错
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
export default new Router({
    routes:[
        {
            path: "/",
            component: (resolve) => require(["../components/index.vue"], resolve),
            meta: {
                title: "Home",
                type: "login",
                alias: "系统首页",
            },
            children:[
                {
                    path:"/courseCenter",
                    component: (resolve) => require(["../components/courseCenter/index.vue"], resolve),
                    meta: {
                        title: "courseCenter",
                        type: "login",
                        alias: "课程中心",
                    },
                },
                {
                    path:"/experimentCenter",
                    component: (resolve) => require(["../components/courseCenter/index.vue"], resolve),
                    meta: {
                        title: "experimentCenter",
                        type: "login",
                        alias: "实训中心",
                    },
                },
                {
                    path:"/courseDetails",
                    component: (resolve) => require(["../components/courseCenter/courseDetails/index.vue"], resolve),
                    meta: {
                        title: "courseDetails",
                        type: "login",
                        alias: "课程详情",
                    },
                },
                {
                    path:"/study",
                    component: (resolve) => require(["../components/courseCenter/courseDetails/courseDetails.vue"], resolve),
                    meta: {
                        title: "study",
                        type: "login",
                        alias: "课程学习",
                    },
                },
                {
                    path:"/resourceCentre",
                    component: (resolve) => require(["../components/resourceCentre/index.vue"], resolve),
                    meta: {
                        title: "resourceCentre",
                        type: "login",
                        alias: "资源中心",
                    },
                },
                {
                    path:"/newsInformation",
                    component: (resolve) => require(["../components/newsInformation/index.vue"], resolve),
                    meta: {
                        title: "newsInformation",
                        type: "login",
                        alias: "新闻咨询",
                    },
                },
                {
                    path:'/newsInformationDetails',
                    name:'newsInformationDetails',
                    component:(resolve) => require(["../components/newsInformation/details.vue"], resolve),
                    meta: {
                        title: "newsInformationDetails",
                        type: "login",
                        alias: "新闻详情",
                    },
                },
                {
                    path:"/searchPage",
                    component: (resolve) => require(["../components/home/searchPage.vue"], resolve),
                    meta: {
                        title: "searchPage",
                        type: "login",
                        alias: "搜索",
                    },
                },
                {
                    path:"/userCenter",
                    component: (resolve) => require(["../components/userCenter/index.vue"], resolve),
                    meta: {
                        title: "userCenter",
                        type: "login",
                        alias: "用户中心",
                    },
                },
                {
                    path:"/editorUserInfo",
                    component: (resolve) => require(["../components/userCenter/editorUserInfo.vue"], resolve),
                    meta: {
                        title: "editorUserInfo",
                        type: "login",
                        alias: "修改个人资料",
                    },
                },
            ]
        },
        {
            path:"/login",
            component: (resolve) => require(["../components/login/index.vue"], resolve),
            meta: {
                title: "login",
                type: "login",
                alias: "登录",
            },
        },
        {
            path:"/examination",
            component: (resolve) => require(["../components/examination/index.vue"], resolve),
            meta: {
                title: "examination",
                type: "login",
                alias: "考试",
            },
        },{
            path:"/examinationDetails",
            component: (resolve) => require(["../components/examination/details.vue"], resolve),
            meta: {
                title: "examinationDetails",
                type: "login",
                alias: "考试详情",
            },
        },
        
    ]
})
